import { t } from '@moovly/i18n';
import * as React from 'react';
import { Table, TableBody, TableHeadCol, TableHeader, TableLoader, TableRow } from '../../../../components/Table';
import useSortableTableHeader from '../../../../hooks/useSortableTableHeader';
import { LicenseData } from '../../../subscriptions/types/licenses';
import { RemoveMemberProps } from '../../modals/RemoveMemberModal';
import UsersTableRow from './UsersTableRow';

export interface TableUser {
  uuid: string;
  name: string;
  emailAddress?: string;
  lastLoginAt?: string;
  projectCount?: number;
  licenseName?: string;
  licenseExpiresAt?: string;
  role: string;
  license?: LicenseData;
  memberId?: string;
}
interface UsersTableProps {
  users: TableUser[];
  onRemoveMember: (member: RemoveMemberProps) => void;
  onRevoke: (license: LicenseData) => void;
  isLoading?: boolean;
}
const headCells = [
  {
    id: 'name',
    numeric: false,
  },
  {
    id: 'emailAddress',
    numeric: false,
  },
  {
    id: 'lastLoginAt',
    numeric: false,
  },
  {
    id: 'projectCount',
    numeric: true,
  },
  {
    id: 'licenseName',
    numeric: false,
  },
  {
    id: 'licenseExpiresAt',
    numeric: false,
  },
  {
    id: 'role',
    numeric: false,
  },
];

const UsersTable: React.FC<UsersTableProps> = ({ users, onRemoveMember, onRevoke, isLoading }) => {
  const handleRemoveMember = React.useCallback((member: RemoveMemberProps) => onRemoveMember(member), [onRemoveMember]);
  const handleRevoke = React.useCallback((license: LicenseData) => onRevoke(license), [onRevoke]);
  const { SortableTableHeader, sortedData } = useSortableTableHeader(users);
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            {headCells.map(
              (cell) => (
                <SortableTableHeader sortBy={cell.id} key={cell.id} label={t(`seats.table.headers.${cell.id}`)} />
              ),
              []
            )}
            <TableHeadCol>Actions</TableHeadCol>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sortedData.map((user: TableUser) => (
            <UsersTableRow
              user={user}
              key={`users-table-user-${user.uuid}`}
              onRemoveMember={handleRemoveMember}
              onRevoke={handleRevoke}
            />
          ))}
          {isLoading && <TableLoader columnns={8} rows={8} />}
        </TableBody>
      </Table>
    </>
  );
};
export default UsersTable;
